const STORAGE_KEY = "finprotection-join-flow";

export const JOIN_FLOW_PATHS = [
  "/join/permission",
  "/join/accessibility-guide",
  "/join/verify",
  "/join/captcha",
  "/join/plan",
  "/join/terms",
  "/home-free",
  "/join/pin",
  "/join/complete",
];

const defaultState = () => ({
  telco: "LGUP",
  phoneNum: "",
  isAuthed: false,
  captchaKey: "",
  resumeSend: false,
});

export const useJoinFlow = () => {
  const read = () => {
    if (!import.meta.client) return defaultState();
    try {
      const raw = sessionStorage.getItem(STORAGE_KEY);
      return raw ? { ...defaultState(), ...JSON.parse(raw) } : defaultState();
    } catch {
      return defaultState();
    }
  };

  const write = (patch = {}) => {
    const next = { ...read(), ...patch };
    if (import.meta.client) {
      sessionStorage.setItem(STORAGE_KEY, JSON.stringify(next));
    }
    return next;
  };

  const clear = () => {
    if (import.meta.client) {
      sessionStorage.removeItem(STORAGE_KEY);
    }
  };

  const ensureCaptchaKey = () => {
    const current = read();
    if (current.captchaKey) return current.captchaKey;
    const captchaKey = crypto.randomUUID();
    write({ captchaKey });
    return captchaKey;
  };

  const requireVerified = async () => {
    const current = read();
    if (!current.isAuthed || !current.phoneNum) {
      await navigateTo("/join/verify", { replace: true });
      return false;
    }
    return true;
  };

  const isJoinFlowPath = (path) => JOIN_FLOW_PATHS.includes(path);

  return {
    read,
    write,
    clear,
    ensureCaptchaKey,
    requireVerified,
    isJoinFlowPath,
  };
};
